import styled from 'styled-components';

export const MapMiddleBodyParentContainer = styled.div`
  width: 100%;
  background: ${(props) => props?.themeBackground};
`;
